import React from 'react';
import { Button, Card, Col, Row } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';

import { ButtonSplitGroup } from '@components/Buttons';
import { DidGroupDeleteInfo } from '@components/Capacity/DidGroups/Delete';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { Page404, Page500 } from '@containers/ErrorPages';
import { didGroupsApi } from '@reducers/capacity';

export const Delete = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const didGroupDetails = didGroupsApi.useGetDetailsQuery({
    id,
  });
  const [deleteQuery, deleteResult] = didGroupsApi.useDeleteDidGroupMutation();

  if (didGroupDetails.isLoading || didGroupDetails.isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (didGroupDetails.isError) {
    return <Page500 />;
  }
  if (!didGroupDetails.data) {
    return <Page404 />;
  }

  return (
    <>
      <Card className="mb-2">
        <Card.Header className="bg-didxl text-white">
          Delete DID-Group: {didGroupDetails.data.country},{' '}
          {didGroupDetails.data.plan}, DID-Group -{' '}
          <span className="fw-bold">{didGroupDetails.data.name}</span>
        </Card.Header>
        <Card.Body>
          <Row>
            <Col md={6}>
              Are you sure you want to delete DID-Group{' '}
              <span className="fw-bold">{didGroupDetails.data.name}</span>?
            </Col>
          </Row>
          <Row className="mt-2">
            <Col>
              <ButtonSplitGroup>
                <Button
                  variant="didxl"
                  onClick={() => {
                    deleteQuery({ id })
                      .unwrap()
                      .then(() => navigate('/capacity/did-groups/existing'));
                  }}
                  size="sm"
                  disabled={deleteResult.isLoading || deleteResult.isFetching}
                >
                  Delete
                </Button>
                <Button
                  variant="didxl-danger"
                  onClick={() => navigate(`/capacity/did-groups/${id}/edit`)}
                  size="sm"
                >
                  Cancel
                </Button>
              </ButtonSplitGroup>
            </Col>
          </Row>
        </Card.Body>
      </Card>
      <Card>
        <Card.Header className="bg-didxl text-white" />
        <Card.Body>
          <DidGroupDeleteInfo />
        </Card.Body>
      </Card>
    </>
  );
};
